import { makeApiCall } from "../makeApiCall";
import { AdminService_URL } from "../Url";

export const pickerDashboardActions = {
  FETCH_PICKER_DASHBOARDDATA_SUCCESS: "FETCH_PICKER_DASHBOARDDATA_SUCCESS",
  FETCH_PICKER_DASHBOARDDATA_FAILURE: "FETCH_PICKER_DASHBOARDDATA_FAILURE",
  FETCH_PICKER_DASHBOARD_SUCCESS: "FETCH_PICKER_DASHBOARD_SUCCESS",
  FETCH_PICKER_DASHBOARD_FAILURE: "FETCH_PICKER_DASHBOARD_FAILURE",
};

//////? Old Service for stats

export function fetchPickerStatsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: pickerDashboardActions.FETCH_PICKER_DASHBOARDDATA_SUCCESS,
      payload: props,
    });
  };
}

export function fetchPickerStatsError(error) {
  return {
    type: pickerDashboardActions.FETCH_PICKER_DASHBOARDDATA_FAILURE,
    payload: error,
  };
}

// get picker dashboard data
export function fetchPickerStats(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };

  const getUrl = `${AdminService_URL}/fetchPickerPwaStats?fromDate=${
    props.fromDate
  }&toDate=${props.toDate}${
    props.isExportCsv ? `&isExportCsv=${props.isExportCsv}` : ""
  }&isFreePickerAvailable=${props.isFreePickerAvailable}${
    props.active ? `&active=${props.active}` : ""
  }`;

  // const getUrl = props.isExportCsv
  //   ? `https://e4f91a4d-ca3c-4579-9492-2feecab6f37a.mock.pstmn.io/fetchPickerPwaStats?fromDate=${props.fromDate}&toDate=${props.toDate}&isExportCsv=${props.isExportCsv}`
  //   : `https://e4f91a4d-ca3c-4579-9492-2feecab6f37a.mock.pstmn.io/fetchPickerPwaStats?fromDate=${props.fromDate}&toDate=${props.toDate}`;

  return makeApiCall(
    getUrl,
    fetchPickerStatsSuccess,
    fetchPickerStatsError,
    "POST",
    props.body,
    reqHeader,
    props.history
  );
}

////? Picker Dashboard Service

export function fetchPickerDashboardSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: pickerDashboardActions.FETCH_PICKER_DASHBOARD_SUCCESS,
      payload: props,
    });
  };
}

export function fetchPickerDashboardError(error) {
  return {
    type: pickerDashboardActions.FETCH_PICKER_DASHBOARD_FAILURE,
    payload: error,
  };
}

// get picker dashboard data
export function fetchPickerDashboard(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_URL}/fetchPickerDashboard?fromDate=${props.fromDate}&toDate=${props.toDate}&isFreePickerAvailable=${props.isFreePickerAvailable}`;
  // const getUrl = `https://e4f91a4d-ca3c-4579-9492-2feecab6f37a.mock.pstmn.io/fetchPickerDashboard?fromDate=${props.fromDate}&toDate=${props.toDate}`;
  return makeApiCall(
    getUrl,
    fetchPickerDashboardSuccess,
    fetchPickerDashboardError,
    "POST",
    props.body,
    reqHeader,
    props.history
  );
}
